export default __webpack_public_path__ + "static/media/christmas-song.969e5de6.mp3";